import { render } from "./AlertSystem.vue?vue&type=template&id=538c21e6&scoped=true"
import script from "./AlertSystem.vue?vue&type=script&lang=js"
export * from "./AlertSystem.vue?vue&type=script&lang=js"

import "./AlertSystem.vue?vue&type=style&index=0&id=538c21e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-538c21e6"]])

export default __exports__